var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/images/blue-button.png": "d4a3",
	"./assets/images/caution.png": "b75b",
	"./assets/images/entrance.jpeg": "abee",
	"./assets/images/exit.png": "8c7b",
	"./assets/images/learning.png": "e9fa",
	"./assets/images/level1-expl.png": "47ad",
	"./assets/images/level1.png": "8071",
	"./assets/images/level3-expl.png": "3524",
	"./assets/images/level3.png": "6a95",
	"./assets/images/logo.png": "9d64",
	"./assets/images/maloha1.png": "14fc",
	"./assets/images/maloha12.png": "c377",
	"./assets/images/maloha3.png": "154f",
	"./assets/images/maloha4.png": "489b",
	"./assets/images/memory.png": "6432",
	"./assets/images/memory1-expl.png": "09ef",
	"./assets/images/memory1.png": "46b2",
	"./assets/images/memory1b.png": "77cf",
	"./assets/images/memory1c.png": "4ce5",
	"./assets/images/memory1d.png": "aa21",
	"./assets/images/memory2-expl.png": "fff1",
	"./assets/images/memory2.png": "5be9",
	"./assets/images/memory2b.png": "f031",
	"./assets/images/memory2c.png": "d5a4",
	"./assets/images/memory2d.png": "9c80",
	"./assets/images/memory3-expl.png": "a483",
	"./assets/images/memory3.png": "3b3a",
	"./assets/images/memory3b.png": "9955",
	"./assets/images/memory3c.png": "cd80",
	"./assets/images/memory3d.png": "eef1",
	"./assets/images/musical-key.jpeg": "5cd7",
	"./assets/images/numbers1.png": "a78f",
	"./assets/images/numbers2.png": "e7db",
	"./assets/images/numbers3.png": "3fda",
	"./assets/images/numbers4.png": "c7f1",
	"./assets/images/party.jpeg": "817b",
	"./assets/images/party2.jpg": "f610",
	"./assets/images/room1.jpeg": "ead1",
	"./assets/images/room2.jpeg": "4ec9a",
	"./assets/images/room3.jpeg": "beb5",
	"./assets/images/room4.jpeg": "a0b7",
	"./assets/images/room5.jpeg": "348e",
	"./assets/images/room6.jpeg": "53ab",
	"./assets/images/room7.jpeg": "d284",
	"./assets/images/room8.jpeg": "7639",
	"./assets/images/search-game.jpeg": "2714",
	"./assets/images/search.jpeg": "f23e",
	"./assets/images/shanghai.gif": "5154",
	"./assets/images/shop2.png": "527c",
	"./assets/images/shopping1.png": "75f1",
	"./assets/images/shopping2.png": "0d2e",
	"./assets/images/story2-expl.png": "8b3d",
	"./assets/images/storyfour.png": "933d",
	"./assets/images/storyone.png": "97e2",
	"./assets/images/storythree.png": "f6f4",
	"./assets/images/storytwo.png": "712a",
	"./assets/images/talk-cloud.png": "be7d",
	"./assets/images/talking-expl.png": "6897",
	"./assets/images/talking.gif": "4b31",
	"./assets/images/trophy.png": "4b12",
	"./assets/images/water.png": "052b",
	"./assets/images/weg/11846639_1479506852343383_3084841854848038747_n.jpg": "8cae",
	"./assets/images/weg/13932863_1588564664770934_1013832754847865201_n.jpg": "2e82",
	"./assets/images/weg/15079104_1626348720992528_7323420395675625754_n.jpg": "faef",
	"./assets/images/weg/17103670_1666970950263638_7960726572690160356_n.jpg": "2aeb",
	"./assets/images/weg/arrow.png": "1416",
	"./assets/images/weg/crab.jpg": "ed9a",
	"./assets/images/weg/crab2.jpg": "f300",
	"./assets/json/land": "c780",
	"./assets/json/land.json": "c780",
	"./assets/json/levels": "2f0e",
	"./assets/json/levels.json": "2f0e",
	"./assets/json/songs": "49f5",
	"./assets/json/songs.json": "49f5",
	"./assets/json/stories": "8325",
	"./assets/json/stories.json": "8325",
	"./assets/json/storyfour": "a5b4",
	"./assets/json/storyfour.json": "a5b4",
	"./assets/json/storyone": "d9c3",
	"./assets/json/storyone.json": "d9c3",
	"./assets/json/storythree": "5d2d",
	"./assets/json/storythree.json": "5d2d",
	"./assets/json/twostory": "be5b",
	"./assets/json/twostory.json": "be5b",
	"./assets/json/write": "66c2",
	"./assets/json/write.json": "66c2",
	"./assets/logo.png": "cf05",
	"./assets/logo.svg": "9b19",
	"./assets/sentences/1-10.mp3": "88e3",
	"./assets/sentences/1-yi.mp3": "e729",
	"./assets/sentences/10-shi.mp3": "c30e",
	"./assets/sentences/2-er.mp3": "2ce9",
	"./assets/sentences/3-san.mp3": "918f",
	"./assets/sentences/4-si.mp3": "ba55",
	"./assets/sentences/5-wu.mp3": "7e36",
	"./assets/sentences/6-liu.mp3": "1070",
	"./assets/sentences/7-qi.mp3": "9c59",
	"./assets/sentences/8-ba.mp3": "08e6",
	"./assets/sentences/9-jiu.mp3": "f501",
	"./assets/sentences/hen_gao_xing_jian_dao_ni.mp3": "53e7",
	"./assets/sentences/hen_hao.mp3": "7206",
	"./assets/sentences/jian_guo-name.mp3": "9fce",
	"./assets/sentences/ni_hao.mp3": "9330",
	"./assets/sentences/ni_hao_ma.mp3": "aba8",
	"./assets/sentences/ni_jiao_shen_me_ming_ze.mp3": "3b56",
	"./assets/sentences/ni_ne.mp3": "7ee7",
	"./assets/sentences/ni_zen_me_yang.mp3": "d925",
	"./assets/sentences/wo_jiao.mp3": "23ec",
	"./assets/sentences/wo_jiao_jian_guo_ni_ne.mp3": "b7d2",
	"./assets/sentences/wo_jiao_yu_ting.mp3": "2628",
	"./assets/sentences/wo_jiao_yu_ting_ni_ne.mp3": "bcd5",
	"./assets/sentences/wo_ye_hen_hao.mp3": "222c",
	"./assets/sentences/xie_xie.mp3": "0a2b",
	"./assets/sentences/zai_jian.mp3": "ab63",
	"./assets/sentences2/bing-cold.mp3": "827f",
	"./assets/sentences2/bu-not.mp3": "2369",
	"./assets/sentences2/cha-tea.mp3": "410b",
	"./assets/sentences2/chi-eat.mp3": "a4a0",
	"./assets/sentences2/fan.mp3": "6958",
	"./assets/sentences2/he-and.mp3": "b388",
	"./assets/sentences2/he-drink.mp3": "fa54",
	"./assets/sentences2/mian.mp3": "bfe4",
	"./assets/sentences2/ni-you.mp3": "ec11",
	"./assets/sentences2/ni_chi_shen_me.mp3": "07e0",
	"./assets/sentences2/ni_he_shen_me.mp3": "52c2",
	"./assets/sentences2/ri-hot.mp3": "7317",
	"./assets/sentences2/shen_me.mp3": "d166",
	"./assets/sentences2/shui-water.mp3": "61db",
	"./assets/sentences2/wo.mp3": "c9f4",
	"./assets/sentences2/wo_chi_fan.mp3": "3757",
	"./assets/sentences2/wo_chi_fan1.mp3": "836e",
	"./assets/sentences2/wo_chi_fan2.mp3": "5df3",
	"./assets/sentences2/wo_ye_he_cha.mp3": "8ba8",
	"./assets/sentences2/ye-also.mp3": "b803",
	"./assets/sentences2/yu-fish.mp3": "af6a",
	"./assets/sentences3/1.mp3": "5cb2",
	"./assets/sentences3/2.mp3": "9c1b",
	"./assets/sentences3/3.mp3": "ecdf",
	"./assets/sentences3/4.mp3": "fd83",
	"./assets/sentences3/beijing.mp3": "aa31",
	"./assets/sentences3/chukou.mp3": "e17d",
	"./assets/sentences3/fire.mp3": "ede8",
	"./assets/sentences3/hongkong.mp3": "72c4",
	"./assets/sentences3/mountain.mp3": "8b9b",
	"./assets/sentences3/rukou.mp3": "e0a7",
	"./assets/sentences3/shangdian.mp3": "9018",
	"./assets/sentences3/shanghai.mp3": "f3c8",
	"./assets/sentences3/water.mp3": "87bd",
	"./assets/sentences3/wo_de_dianhua_haoma_shi.mp3": "9c23",
	"./assets/sentences3/wo_de_dianhua_haoma_shi2.mp3": "425c",
	"./assets/sentences3/xiaoxin.mp3": "6907",
	"./assets/sentences3/zen_me_shuo.mp3": "0f3c",
	"./assets/songs/beterestemopname.mp3": "822d",
	"./assets/songs/jostiband3.mp3": "d795",
	"./assets/songs/level_1_chinese_song.mp3": "6ff0",
	"./assets/songs/wo_chi_fan_song_level2.mp3": "c70a",
	"./assets/songs/yi_er_san_song_level3.mp3": "fb74",
	"./assets/stories/storyone.mp3": "4b9a",
	"./components/AnswerCard": "35e9",
	"./components/AnswerCard.vue": "35e9",
	"./components/HelloWorld": "fdab",
	"./components/HelloWorld.vue": "fdab",
	"./components/LevelListitem": "06a2",
	"./components/LevelListitem.vue": "06a2",
	"./components/MemoryCard": "0e87",
	"./components/MemoryCard.vue": "0e87",
	"./components/MenuBanner": "7c6b",
	"./components/MenuBanner.vue": "7c6b",
	"./components/PopUp": "dacb",
	"./components/PopUp.vue": "dacb",
	"./components/PopUpAchieve": "0915",
	"./components/PopUpAchieve.vue": "0915",
	"./components/PopUpReturn": "c2f1",
	"./components/PopUpReturn.vue": "c2f1",
	"./components/SearchObject": "5693",
	"./components/SearchObject.vue": "5693",
	"./components/SongCard": "c486",
	"./components/SongCard.vue": "c486",
	"./components/SongListitem": "54e9",
	"./components/SongListitem.vue": "54e9",
	"./components/SoundButton": "3b48",
	"./components/SoundButton.vue": "3b48",
	"./components/SoundButtonSmall": "cc22",
	"./components/SoundButtonSmall.vue": "cc22",
	"./components/SoundCard": "2643",
	"./components/SoundCard.vue": "2643",
	"./components/Words": "2e4c",
	"./components/Words.vue": "2e4c",
	"./main": "56d7",
	"./main.js": "56d7",
	"./plugins/vuetify": "402c",
	"./plugins/vuetify.js": "402c",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./scss/global/_variables.scss": "93b1",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./views/About": "f820",
	"./views/About.vue": "f820",
	"./views/Games": "a2e9",
	"./views/Games.vue": "a2e9",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/Land": "d6aa",
	"./views/Land.vue": "d6aa",
	"./views/Memory": "e39b",
	"./views/Memory.vue": "e39b",
	"./views/Memory2": "9fe5",
	"./views/Memory2.vue": "9fe5",
	"./views/Memory3": "b02c",
	"./views/Memory3.vue": "b02c",
	"./views/OneStory": "e854",
	"./views/OneStory.vue": "e854",
	"./views/SearchGame": "c794",
	"./views/SearchGame.vue": "c794",
	"./views/Shop": "0fa5",
	"./views/Shop.vue": "0fa5",
	"./views/Songs": "82d2",
	"./views/Songs.vue": "82d2",
	"./views/Stories": "dcfc",
	"./views/Stories.vue": "dcfc",
	"./views/StoryFour": "ea56",
	"./views/StoryFour.vue": "ea56",
	"./views/StoryThree": "8c42",
	"./views/StoryThree.vue": "8c42",
	"./views/StoryTwo": "4ecf",
	"./views/StoryTwo.vue": "4ecf",
	"./views/TalkPage": "5457",
	"./views/TalkPage.vue": "5457",
	"./views/Talking": "16be",
	"./views/Talking.vue": "16be",
	"./views/Write": "ed6a",
	"./views/Write.vue": "ed6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";